import { API_CALLS } from "../../../services/apis";
export default {
  getCategories() {
    return new Promise((resolve, reject) => {
      API_CALLS.getCategoriesAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getCategory(context, id) {
    return new Promise((resolve, reject) => {
      API_CALLS.getCategoryAPI(id)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putCategoryConf(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.putCategoryConfAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postNewSubCategory(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.postNewSubCategoryAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postNewRootCategory(context, data) {
    return new Promise((resolve, reject) => {
      API_CALLS.postNewRootCategoryAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDropdowns() {
    return new Promise((resolve, reject) => {
      API_CALLS.getDropdownsAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getCurrencies() {
    return new Promise((resolve, reject) => {
      API_CALLS.getCurrenciesAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
